import { StatsigClient } from '@statsig/js-client'

let Statsig = null

export function getABTProvider() {
  return {
    isFeatureEnabled(featureName) {
      return Statsig?.checkGate(featureName)
    },

    getExperiment(experimentName) {
      return Statsig?.getExperiment(experimentName)?.value
    },

    getConfigurations(configureName) {
      return Statsig?.getDynamicConfig(configureName)?.value
    },

    async updateUser(user) {
      return Statsig?.updateUserAsync(user)
    },

    shutdown() {
      return Statsig?.shutdown()
    },
  }
}

export async function initialize(sdkKey, user, options) {
  Statsig = new StatsigClient(sdkKey, user, options)
  await Statsig.initializeAsync()
}
